<template>
  <div class="overlay" @click.self="$emit('fechar')">
    <div class="modal-filtros">
      <div class="modal-header">
        <span class="modal-label">Filtros Parcerias</span>
        <button type="button" class="btn-fechar-modal" aria-label="Fechar filtros" @click="$emit('fechar')">
          ×
        </button>
      </div>

      <div class="modal-corpo">
        <div class="filtro-secao">
          <p class="coluna-titulo">Unidade da UFC:</p>

          <select v-model="filtros.unidadeId" class="select-unidade" :disabled="carregandoUnidades">
            <option value="">
              {{
                carregandoUnidades
                  ? "Carregando unidades..."
                  : "Todas as unidades"
              }}
            </option>

            <option v-for="unidade in unidades" :key="unidade.id" :value="String(unidade.id)">
              {{ unidade.nome }}
            </option>
          </select>
        </div>
        <div class="filtro-secao">
          <p class="coluna-titulo">Tipo de parcerias:</p>

          <select v-model="filtros.jaFormalizada" class="select-unidade">
            <option value="">Todos os tipos</option>
            <option value="true">Formalizadas</option>
            <option value="false">Não formalizadas</option>
          </select>
        </div>

        <div class="filtro-secao">
          <p class="coluna-titulo">Área de Atuação:</p>

          <select v-model="filtros.area" class="select-unidade">
            <option value="">Todas as áreas</option>

            <option v-for="area in areasExtensao" :key="area" :value="area">
              {{ area }}
            </option>
          </select>
        </div>
      </div>

      <div class="modal-rodape">
        <button type="button" class="btn-limpar" @click="limparFiltros">
          Limpar filtros
        </button>

        <button type="button" class="btn-filtrar" :disabled="carregandoUnidades" @click="aplicarFiltros">
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import unidadesService from "@/service/unidadesService";

const props = defineProps({
  filtrosIniciais: {
    type: Object,
    default: () => ({
      unidadeId: null,
      area: null,
      jaFormalizada: null,
    }),
  },
});

const emit = defineEmits(["fechar", "aplicarFiltros"]);

const unidades = ref([]);
const carregandoUnidades = ref(false);

const areasExtensao = [
  "Tecnologia e Produção",
  "Meio Ambiente",
  "Trabalho",
  "Cultura",
  "Direitos Humanos e Justiça",
  "Saúde",
  "Educação",
  "Comunicação",
];

function normalizarFiltros(valores = {}) {
  return {
    unidadeId: valores.unidadeId ?? valores.local ?? "",
    area: valores.area ?? "",
    jaFormalizada:
      valores.jaFormalizada === true ||
        valores.jaFormalizada === "true"
        ? "true"
        : valores.jaFormalizada === false ||
          valores.jaFormalizada === "false"
          ? "false"
          : "",
  };
}

const filtros = ref(normalizarFiltros(props.filtrosIniciais));

watch(
  () => props.filtrosIniciais,
  (novosFiltros) => {
    filtros.value = normalizarFiltros(novosFiltros);
  },
  { deep: true },
);

async function carregarUnidades() {
  carregandoUnidades.value = true;

  try {
    const resposta = await unidadesService.getAllUnidades(0, 1000);

    const dados = Array.isArray(resposta)
      ? resposta
      : Array.isArray(resposta?.data)
        ? resposta.data
        : Array.isArray(resposta?.data?.content)
          ? resposta.data.content
          : Array.isArray(resposta?.content)
            ? resposta.content
            : [];

    unidades.value = dados
      .filter((unidade) => unidade.id != null)
      .map((unidade) => ({
        id: unidade.id,
        nome: unidade.nome ?? unidade.label ?? `Unidade ${unidade.id}`,
      }))
      .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
  } catch (erro) {
    console.error("Erro ao carregar unidades para o filtro:", erro);
    unidades.value = [];
  } finally {
    carregandoUnidades.value = false;
  }
}

function emitirFiltros() {
  emit("aplicarFiltros", {
    unidadeId: filtros.value.unidadeId || null,
    area: filtros.value.area || null,
    jaFormalizada:
      filtros.value.jaFormalizada === ""
        ? null
        : filtros.value.jaFormalizada,
  });
}

function limparFiltros() {
  filtros.value = {
    unidadeId: "",
    area: "",
    jaFormalizada: "",
  };

  emitirFiltros();
  emit("fechar");
}

function aplicarFiltros() {
  emitirFiltros();
  emit("fechar");
}

onMounted(carregarUnidades);
</script>

<style scoped>
.modal-filtros {

  width: 400px;

}

.modal-corpo {
  display: flex;
  flex-direction: column;
  background: var(--branco);
  gap: 24px;
}



.filtro-secao {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--preto);
  margin: 0;
}

.select-unidade {
  padding: 10px;
  border: 1px solid var(--cinza-medio);
  border-radius: 8px;
  font-size: 0.9rem;
  outline: none;
  width: 100%;
  background: var(--branco);
}

.select-unidade {
  padding-right: 32px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.select-unidade:focus {
  border-color: var(--roxo-medio);
}



.btn-limpar {
  border: 2px solid var(--roxo-medio);
  background: var(--branco);
  color: var(--roxo-medio);
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-limpar:hover {
  background: var(--roxo-superficie);
}

.btn-filtrar {
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-filtrar:hover {
  background: var(--roxo-medio);
}
</style>
